module.exports = __webpack_public_path__ + "static/media/mmsys_102.9b0c7d3e.ico";